package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/goat". Pulls the REAL cached analysis (baked in StaticReviews). */
@Page("/isitsafe/goat")
@Composable
fun GoatReviewPage() {
    PublicReviewPage(
        slug = "goat",
        blurb = "Is GOAT OK for Muslim kids? Fitrah Filter checks movies, shows, games, and books against Islamic values. Here's the full breakdown for parents.",
    )
}
